module.exports = __webpack_public_path__ + "static/media/guide_1.eeda8835.gif";